import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface PartnershipEAFMInterface {
 'RESULTS.DATA.INVESTMENT'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.ANI'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.IROE'?: ResultRow;
}
export class PartnershipEAFM {
  'RESULTS.DATA.INVESTMENT';
  'RESULTS.DATA.ECONOMIC_METRICS.ANI';
  'RESULTS.DATA.ECONOMIC_METRICS.IROE';
  get investment() {
    return this['RESULTS.DATA.INVESTMENT'];
  }
  set investment(value: ResultRow) {
    this['RESULTS.DATA.INVESTMENT'] = value;
  }
  /** average net income */
  get ani() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.ANI'];
  }
  set ani(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.ANI'] = value;
  }
  /** individual ROE */
  get iroe() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.IROE'];
  }
  set iroe(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.IROE'] = value;
  }

  constructor(param: PartnershipEAFMInterface = {}) {
    this['RESULTS.DATA.INVESTMENT'] = param['RESULTS.DATA.INVESTMENT']
      ? new ResultRow(param['RESULTS.DATA.INVESTMENT'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.ANI'] = param['RESULTS.DATA.ECONOMIC_METRICS.ANI']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.ANI'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.IROE'] = param['RESULTS.DATA.ECONOMIC_METRICS.IROE']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.IROE'])
      : new ResultRow();
  }

  deepCopy() {
    return new PartnershipEAFM(cloneDeep(this));
  }
}

export function makePartnership(partnership: PartnershipEAFMInterface) {
  return new PartnershipEAFM(partnership);
}